import { useEffect, useState } from "react";
import OverlayShell from "./OverlayShell";
import { ActionButton } from "./styles";
import { DEMO_ACTIVATION_CODE, DEMO_BALANCE, IMAGES } from "./images";
import copyIcon from "./imgs/copy-icon.svg";

const Balance = ({ onClose, onTrackButtonClick }) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return undefined;
    const timeoutId = setTimeout(() => setCopied(false), 2000);
    return () => clearTimeout(timeoutId);
  }, [copied]);

  return (
    <OverlayShell title="Harbor Pay" image={IMAGES.spend} onClose={onClose}>
      <div className="section">
        <p>
          Use the spend on your band at food, drink and merchandise points
          around the venue. This is a demo balance for the event platform.
        </p>
        <div className="balance-figure">
          <p className="muted">Remaining balance</p>
          <p className="balance-value">{DEMO_BALANCE}</p>
        </div>
      </div>
      <div className="section">
        <p className="bold">Activation code</p>
        <p>Keep this code to link Harbor Pay after the event.</p>
        <div className="activation-code">
          <p>{DEMO_ACTIVATION_CODE}</p>
          <button
            className="copy-button"
            type="button"
            aria-label="Copy activation code"
            onClick={() => {
              onTrackButtonClick?.("copy_activation_code", "balance_modal");
              navigator.clipboard.writeText(DEMO_ACTIVATION_CODE);
              setCopied(true);
            }}
          >
            <img src={copyIcon} alt="" />
          </button>
        </div>
        {copied && <p>Copied to clipboard</p>}
        <ActionButton type="button" onClick={onClose}>
          Done
        </ActionButton>
      </div>
    </OverlayShell>
  );
};

export default Balance;
